@if (showLabel()) {
  <kendo-label [text]="attribute().name" class="attribute-field__label">
    @if (attribute().required) {
      <span class="attribute-field__required">*</span>
    }
    @if (attribute().description) {
      <i
        class="fa-light fa-circle-info attribute-field__info"
        [title]="attribute().description!"
        aria-label="Attribute help"
      ></i>
    }
  </kendo-label>
}

<div class="attribute-field__control-row">
  <div class="attribute-field__control">
    @switch (controlType()) {
      @case ('number') {
        <kendo-numerictextbox
          [formControl]="control()"
          class="attribute-field__input"
        ></kendo-numerictextbox>
      }
      @case ('select') {
        <kendo-dropdownlist
          [formControl]="control()"
          [data]="options()"
          textField="label"
          valueField="value"
          [valuePrimitive]="true"
          [loading]="isLoading()"
          [popupSettings]="{ appendTo: 'component' }"
          class="attribute-field__input"
          (open)="onDropdownOpen()"
        >
          <ng-template kendoDropDownListNoDataTemplate>
            @if (isLoading()) {
              <div class="attribute-field__dropdown-loading">
                <kendo-loader type="converging-spinner" size="small"></kendo-loader>
                <span>Loading options...</span>
              </div>
            } @else {
              <span>No options available</span>
            }
          </ng-template>
        </kendo-dropdownlist>
      }
      @case ('multiselect') {
        <kendo-multiselect
          [formControl]="control()"
          [data]="options()"
          textField="label"
          valueField="value"
          [valuePrimitive]="true"
          [filterable]="true"
          [loading]="isLoading()"
          [popupSettings]="{ appendTo: 'component' }"
          class="attribute-field__input"
          (open)="onDropdownOpen()"
        >
          <ng-template kendoMultiSelectNoDataTemplate>
            @if (isLoading()) {
              <div class="attribute-field__dropdown-loading">
                <kendo-loader type="converging-spinner" size="small"></kendo-loader>
                <span>Loading options...</span>
              </div>
            } @else {
              <span>No options available</span>
            }
          </ng-template>
        </kendo-multiselect>
      }
      @case ('date') {
        <kendo-datepicker
          [formControl]="control()"
          class="attribute-field__input"
        ></kendo-datepicker>
      }
      @default {
        <kendo-textbox
          [formControl]="control()"
          class="attribute-field__input"
        ></kendo-textbox>
      }
    }
  </div>

  @if (showRemoveButton()) {
    <button
      type="button"
      class="attribute-field__remove"
      (click)="onRemove()"
      aria-label="Remove attribute"
    >
      <i class="fa-regular fa-trash-xmark" aria-hidden="true"></i>
    </button>
  }
</div>
